// Additional fonts loading functions

// Fonts loading URL
let FONTS_PATH = "";

// Fonts list
let fonts = [];
// Fonts loaded flag
let fontsInited = false;

/**
 * Set path that will be used to load fonts list and font files
 * @param {String} path Fonts loading URL
 */
export const setFontsPath = path => {
  if (path != FONTS_PATH) {
    FONTS_PATH = path;
    fontsInited = false;
  }
};

/**
 * Load fonts
 */
export const initFonts = async () => {
  if (!fontsInited) {
    fonts = await fetchFonts();
    fonts.forEach(font => loadFont(font.name, font.value));
    fontsInited = true;
  }
};

/**
 * Return font names list
 */
export const getFonts = async () => {
  if (!fontsInited) {
    await initFonts();
  }
  return [...fonts.map(f => f.name)];
};

/**
 * Return font file by it's name
 * @param {String} fontName
 */
export const getFontFile = fontName => {
  return fonts.find(f => f.name == fontName).value;
};

/**
 * Fetch fonts list
 */
async function fetchFonts() {
  const fontsListResp = await fetch(FONTS_PATH + "/fonts.json");
  if (fontsListResp.ok) {
    try {
      return await fontsListResp.json();
    } catch (error) {
      console.error(`Failed when parsing fonts: ${error}`);
    }
  } else {
    console.error(
      `Failed when loading fonts - ${fontsListResp.status}: ${fontsListResp.statusText}`
    );
  }

  return [];
}

/**
 * Load font file and add it to site fonts
 * @param {String} fontName
 * @param {String} fontFile
 */
function loadFont(fontName, fontFile) {
  var fontURL = `${FONTS_PATH}/${fontFile}`;
  var fontFace = new FontFace(fontName, `url(${fontURL})`);
  fontFace.load().then(
    loaded => {
      // fonts.push(fontName);
      document.fonts.add(loaded);
      console.log(`'${fontName}' font has loaded`);
    },
    error => {
      console.error(
        `There was an error when loading '${fontName}' font - ${error}`
      );
    }
  );
}
